import pako from "pako";
import JSZip from "jszip";
import { getCachedScript } from "../scriptCache.js";

const DEFAULT_FONT_FAMILY_TOKEN = "58724202-DD58-420B-A6F0-2FBBC812F7B5";

function ppText(rename, whiteText) {
  getCachedScript();
  window.jsx.evalScript(
    "run(ppTextLayer(true," + rename + ", " + whiteText + "));",
    function (data) {
      if (data) {
        handlePremiereProject(data);
      } else {
        alert("Error when selecting a file.");
      }
    },
  );

  async function handlePremiereProject(obj) {
    try {
      const data = JSON.parse(obj);
      const folderPath = data.folder;
      const filePath = folderPath + "/Text.prproj";
      const tempFolder = data.folder + "/Temp";
      const outTextFolder = tempFolder + "/Text";
      const extension = ".prproj";
      const textInfo = Array.isArray(data.data) ? data.data : [];

      // Проверка папок
      ensureFolder(tempFolder);
      ensureFolder(outTextFolder);

      // Читаем исходный .prproj сразу и как base64
      let readRes = await window.cep.fs.readFile(
        filePath,
        window.cep.encoding.Base64,
      );
      if (readRes.err !== 0) {
        alert("Ошибка: не удалось прочитать исходный файл: " + readRes.err);
        return;
      }
      const originalBase64 = readRes.data;

      // Разжимаем исходный файл (gz/deflate → XML)
      const originalBytes = new Uint8Array(base64ToArrayBuffer(originalBase64));
      let xmlString;
      try {
        const inflated = pako.inflate(originalBytes);
        xmlString = new TextDecoder("utf-8").decode(inflated);
      } catch (zerr) {
        alert("Ошибка распаковки исходного prproj: " + zerr);
        return;
      }

      // Проходимся по каждому info последовательно (важно НЕ forEach)
      for (const info of textInfo) {
        try {
          const safeName = String(info.name || "Untitled").replace(
            /[\\/:*?"<>|]/g,
            "_",
          );
          const newPath = `${outTextFolder}/${safeName}${extension}`;

          // Создаём родительскую папку для файла (на случай многоуровневых имён)
          const newPathDir = newPath.split("/").slice(0, -1).join("/");
          ensureFolder(newPathDir);

          // Модифицируем XML под конкретный info
          const modifiedXmlString = modifyXml(xmlString, info);

          // Кодирование строки → байты → gzip
          const modifiedBytes = new TextEncoder().encode(modifiedXmlString);
          const gzippedBytes = pako.gzip(modifiedBytes);

          // Пишем как Base64
          const b64 = arrayBufferToBase64(gzippedBytes.buffer);
          const writeRes = window.cep.fs.writeFile(
            newPath,
            b64,
            window.cep.encoding.Base64,
          );
          if (writeRes.err !== 0) {
            alert("Ошибка при записи файла: " + newPath + " / " + writeRes.err);
            continue;
          }

          // Делаем .mogrt
          await createMogrtArchive(newPath, tempFolder);
        } catch (innerErr) {
          alert(
            "Ошибка при обработке элемента: " +
              (info && info.name ? info.name : "<?>") +
              " — " +
              innerErr,
          );
        }
      }
    } catch (e) {
      alert("Неожиданная ошибка: " + e.toString());
    }
  }

  // === Сборка .mogrt без Blob, только байты ===
  async function createMogrtArchive(newPath, tempFolder) {
    // 1) Читаем .prproj как base64 → байты
    const newPathContent = await window.cep.fs.readFile(
      newPath,
      window.cep.encoding.Base64,
    );
    if (newPathContent.err !== 0) {
      alert("Ошибка при чтении файла newPath: " + newPathContent.err);
      return;
    }
    const prprojBytes = new Uint8Array(
      base64ToArrayBuffer(newPathContent.data),
    );

    // Получаем имя файла
    const fileName = newPath
      .split("/")
      .pop()
      .replace(/[\\/:*?"<>|]/g, "_");

    // 1.1 Создаём внутренний ZIP project.prgraphic
    const projectZip = new JSZip();
    projectZip.file(fileName, prprojBytes); // ВАЖНО: Uint8Array, не Blob
    const projectZipBytes = await projectZip.generateAsync({
      type: "uint8array",
    });

    // 2) Читаем definition.json — как текст (UTF-8)
    const definitionRes = await window.cep.fs.readFile(
      tempFolder + "/definition-text.json",
    );
    if (definitionRes.err !== 0) {
      alert("Ошибка при чтении definition.json: " + definitionRes.err);
      return;
    }
    const definitionText = definitionRes.data || "";

    // 2.1 Собираем внешний ZIP .mogrt
    const mogrtZip = new JSZip();
    mogrtZip.file("project.prgraphic", projectZipBytes); // бинарные байты
    mogrtZip.file("definition.json", definitionText); // строка

    const mogrtBytes = await mogrtZip.generateAsync({ type: "uint8array" });
    const mogrtB64 = arrayBufferToBase64(mogrtBytes.buffer);

    // 2.2 Сохраняем .mogrt рядом
    const outPath = newPath.replace(".prproj", ".mogrt");
    const saveRes = window.cep.fs.writeFile(
      outPath,
      mogrtB64,
      window.cep.encoding.Base64,
    );
    if (saveRes.err !== 0) {
      alert("Ошибка при сохранении .mogrt: " + saveRes.err);
      return;
    }

    // 3) Удаляем исходный временный .prproj (по желанию)
    const del = window.cep.fs.deleteFile(newPath);
    // Не пугаем пользователя, если удалить не получилось
    if (del && del.err && del.err !== 0) {
      // console.warn("Не удалось удалить временный файл:", del.err);
    }
  }

  // Text.prproj holds a single Source Text payload: an 8-byte little-endian
  // length followed by UTF-16LE JSON. It is decoded, restyled and re-encoded as
  // a whole, so any characters (Cyrillic, quotes, line breaks) survive.
  function modifyXml(xmlString, info) {
    const sourceTextPattern =
      /(<Name>Source Text<\/Name>[\s\S]*?<StartKeyframeValue Encoding="base64" BinaryHash=")[^"]*(">)([^<]*)(<\/StartKeyframeValue>)/;
    const match = xmlString.match(sourceTextPattern);
    if (!match) {
      throw new Error("Source Text payload not found in Text.prproj");
    }

    const payload = decodeSourceText(match[3]);
    applyTextStyle(payload.mTextParam, info);
    const encoded = encodeSourceText(payload);

    return xmlString
      .replace(
        sourceTextPattern,
        (all, head, middle, value, tail) =>
          head + encoded.hash + middle + encoded.base64 + "\n\t\t" + tail,
      )
      .replace(
        /<Name>Proxy Sequence<\/Name>/g,
        () => "<Name>" + xmlEscape(info.name) + " Delete</Name>",
      )
      .replace(
        /<OriginalDuration>3810240000000<\/OriginalDuration>/g,
        () =>
          "<OriginalDuration>" +
          Math.round(info.outPoint * 254016000000) +
          "</OriginalDuration>",
      );
  }

  function decodeSourceText(b64) {
    const bytes = new Uint8Array(base64ToArrayBuffer(b64));
    const length = new DataView(bytes.buffer).getUint32(0, true);
    const json = new TextDecoder("utf-16le").decode(
      bytes.subarray(8, 8 + length),
    );
    return JSON.parse(json);
  }

  function encodeSourceText(payload) {
    const json = JSON.stringify(payload);
    const bytes = new Uint8Array(8 + json.length * 2);
    const view = new DataView(bytes.buffer);
    view.setUint32(0, json.length * 2, true);
    for (let i = 0; i < json.length; i++) {
      view.setUint16(8 + i * 2, json.charCodeAt(i), true);
    }
    return {
      base64: arrayBufferToBase64(bytes.buffer),
      hash: makeBinaryHash(bytes.length),
    };
  }

  // Premiere ends a BinaryHash with the payload size in hex.
  function makeBinaryHash(size) {
    const hex = Array.from(
      window.crypto.getRandomValues(new Uint8Array(12)),
      (b) => b.toString(16).padStart(2, "0"),
    ).join("");
    return (
      hex.slice(0, 8) +
      "-" +
      hex.slice(8, 12) +
      "-" +
      hex.slice(12, 16) +
      "-" +
      hex.slice(16, 20) +
      "-" +
      hex.slice(20, 24) +
      size.toString(16).padStart(8, "0")
    );
  }

  // Same rules as importTextLayers.js in ae2-pp-frontend: info.runs comes from
  // ppGetTextStyleRuns (AE), older data falls back to the layer-level fields.
  function applyTextStyle(textParam, info) {
    const text = String(info.mText == null ? "" : info.mText);
    const length = text.length;
    const runs = getStyleRuns(info);
    const styleSheet = textParam.mStyleSheet;
    const fillOverStroke = [];
    for (let i = 0; i < length; i++) fillOverStroke.push([i, false]);
    fillOverStroke.push([length, true]);

    textParam.mAlignment = numberOr(info.mAlignment, 3);
    textParam.mLeading = numberOr(info.mLeading, 0);

    styleSheet.mText = text;
    styleSheet.mBaselineShift = buildRunValues(length, runs, "mBaselineShift", {
      final: runs[0].mBaselineShift,
    });
    styleSheet.mCapsOption = buildRunValues(length, runs, "mCapsOption");
    styleSheet.mFauxBold = buildRunValues(length, runs, "mFauxBold");
    styleSheet.mFauxItalic = buildRunValues(length, runs, "mFauxItalic");
    styleSheet.mFillColor = buildRunValues(length, runs, "mFillColor");
    styleSheet.mFillOverStroke = { mParamValues: fillOverStroke };
    styleSheet.mFillVisible = buildRunValues(length, runs, "mFillVisible");
    styleSheet.mFontName = buildRunValues(length, runs, "mFontName", {
      perChar: true,
      final: DEFAULT_FONT_FAMILY_TOKEN,
    });
    styleSheet.mFontSize = buildRunValues(length, runs, "mFontSize", {
      perChar: true,
      final: 100,
    });
    styleSheet.mStrokeColor = buildRunValues(length, runs, "mStrokeColor", {
      perChar: true,
      final: runs[runs.length - 1].mStrokeColor,
    });
    styleSheet.mStrokeVisible = buildRunValues(length, runs, "mStrokeVisible");
    styleSheet.mStrokeWidth = buildRunValues(length, runs, "mStrokeWidth");
    styleSheet.mTracking = buildRunValues(length, runs, "mTracking", {
      perChar: true,
      final: 0,
    });
  }

  function getStyleRuns(info) {
    const base = {
      start: 0,
      mFontName: String(info.mFontName || "ArialMT"),
      mFontSize: numberOr(info.mFontSize, 100),
      mTracking: numberOr(info.mTracking, 0),
      mFauxBold: !!info.mFauxBold,
      mFauxItalic: !!info.mFauxItalic,
      mCapsOption: numberOr(info.mCapsOption, 0),
      mBaselineShift: numberOr(info.mBaselineShift, 0),
      mFillVisible: info.mFillVisible == null ? true : !!info.mFillVisible,
      mFillColor: numberOr(info.mFillColor, 16777215),
      mStrokeVisible: !!info.mStrokeVisible,
      mStrokeColor: numberOr(info.mStrokeColor, 16777215),
      mStrokeWidth: numberOr(info.mStrokeWidth, 1),
    };
    if (!Array.isArray(info.runs) || !info.runs.length) return [base];
    return info.runs
      .map((run) =>
        Object.assign({}, base, run, { start: numberOr(run.start, 0) }),
      )
      .sort((a, b) => a.start - b.start);
  }

  // Premiere stores character styles as [[charIndex, value], ...]. A single
  // [[0, value]] covers the whole text; per-character lists end with a
  // sentinel entry at text.length, matching what After Effects writes.
  function buildRunValues(length, runs, key, options = {}) {
    const uniform = runs.every((run) => run[key] === runs[0][key]);
    if (uniform && !options.perChar) {
      return { mParamValues: [[0, runs[0][key]]] };
    }

    const values = [];
    let runIndex = 0;
    for (let i = 0; i < length; i++) {
      while (runIndex + 1 < runs.length && runs[runIndex + 1].start <= i) {
        runIndex++;
      }
      values.push([i, runs[runIndex][key]]);
    }
    if ("final" in options) values.push([length, options.final]);
    return { mParamValues: values };
  }

  function numberOr(value, fallback) {
    const number = Number(value);
    return value == null || !Number.isFinite(number) ? fallback : number;
  }

  function xmlEscape(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&apos;");
  }

  function base64ToArrayBuffer(b64) {
    // Убираем всё, кроме валидных символов Base64 (в т.ч. переводы строк/пробелы)
    const clean = String(b64 || "").replace(/[^A-Za-z0-9+/=]/g, "");
    const binary = window.atob(clean);
    const len = binary.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i) & 0xff;
    return bytes.buffer;
  }

  function arrayBufferToBase64(buf) {
    const bytes = new Uint8Array(buf);
    let binary = "";
    const chunk = 0x8000;
    for (let i = 0; i < bytes.length; i += chunk) {
      binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
    }
    return window.btoa(binary);
  }

  // === Утилита: убедиться, что папка существует ===
  function ensureFolder(folderPath) {
    const stat = window.cep.fs.stat(folderPath);
    if (stat.err === 0 && stat.data.isDirectory()) return true;
    const res = window.cep.fs.makedir(folderPath);
    return res.err === 0;
  }
}

export default ppText;
